import { combineReducers } from 'redux'
import basic from './reducerBasic'
import globalEvent from './reducerGlobalEvent'
export default combineReducers({
  basic, // 基本信息
  globalEvent // 全局事件处理函数
})
